var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "c-list c-list--results" },
    _vm._l(_vm.resultsListing, function(item, i) {
      return _c(
        "li",
        { key: i, staticClass: "c-list__item" },
        [
          item
            ? _c(_vm.itemComponent, {
                tag: "component",
                attrs: { item: item, siteUrl: _vm.siteUrl },
                on: { resultClick: _vm.searchResultsItemClick }
              })
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-573d20a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-573d20a3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/results/SearchListing.vue
// module id = 621
// module chunks = 0